<template>
  <div>
    <div class="traffic-light-line">
      <div class="labeled-line">
        <div class="label out-of-date">
          {{ fullMonthName }}
        </div>
        <div class="line out-of-date"></div>
        <div class="circle out-of-date"></div>
      </div>
    </div>
    <div class="pending-cashflow-view-container">
      <expected-end-of-month />
      <riseup-goal />
      <cashflow-type-mock :cashflow-type="'משתנות'"/>
      <cashflow-type-mock :cashflow-type="'סופר'"/>
      <cashflow-type-mock :cashflow-type="'רכב'"/>
      <cashflow-type-mock :cashflow-type="'קבועות'"/>
      <cashflow-type-mock-income />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Segment from '../../../../../../../Segment';
import ExpectedEndOfMonth from './components/ExpectedEndOfMonth.vue';
import RiseupGoal from './components/RiseupGoal.vue';
import CashflowTypeMock from './components/types/CashflowTypeMock.vue';
import CashflowTypeMockIncome from './components/types/CashflowTypeMockIncome.vue';

export default {
  name: 'PendingCashflowView',
  components: {
    ExpectedEndOfMonth,
    RiseupGoal,
    CashflowTypeMock,
    CashflowTypeMockIncome,
  },
  async created() {
    Segment.trackUserGot('PendingCashflowViewEntered');
  },
  computed: {
    ...mapGetters('cashflowView', ['fullMonthName']),
  },
};
</script>


<style lang="scss" scoped>
  @import '../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../scss/mixins';

  .traffic-light-line {
    @include responsive-padding;
    width: 100%;
    text-align: center;
    margin-bottom: 11px;

    .labeled-line {
      width: 100%;
      padding-top: 12px;
      position: relative;
      right: -10px;
      margin-right: 10px;
      display: inline-block;

      .out-of-date {
        background-color: $riseup_gray_1;
      }

      .label {
        height: 18px;
        line-height: 15px;
        font-size: 14px;
        padding: 2px 4px 2px 4px;
        display: inline-block;
        color: $riseup_white;
        font-weight: bold;
        position: absolute;
        right: 0;
        top: -3px;
      }

      .line {
        height: 3px;
      }

      .circle {
        position: absolute;
        left: 0;
        top: 5px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: inline-block;
      }
    }
  }

  .pending-cashflow-view-container {
    @include responsive-padding;
    font-family: SimplerPro;
    text-align: right;
    width: 100%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/PendingCashflowView.vue